import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCategories } from '../../../hooks/useCategories';
import LoadingSpinner from '../../common/LoadingSpinner/LoadingSpinner';
import SEO, { buildCategoriesListSeo } from '../../common/SEO/SEO';
import SchemaOrg, { buildCategoriesListSchema } from '../../common/SEO/SchemaOrg';

const CategoriesPage = () => {
  const { categories, loading, error } = useCategories();
  const navigate = useNavigate();

  if (loading) {
    return <LoadingSpinner message="Cargando categorías..." />;
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-red-600 mb-4">Error</h2>
          <p className="text-gray-600">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <>
    <SEO {...buildCategoriesListSeo(categories)} />
    <SchemaOrg schemas={[buildCategoriesListSchema(categories)].filter(Boolean)} />
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Todas Nuestras Especialidades
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Explora todas las categorías de trámites que manejamos.
            Cada especialidad cuenta con expertos dedicados y procesos optimizados.
          </p>
        </div>

        {/* Categories Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {categories.map((category) => (
            <CategoryCard
              key={category.id}
              category={category}
              onClick={() => navigate(`/categoria/${category.slug}`)}
            />
          ))}
        </div>
      </div>
    </div>
    </>
  );
};

const CategoryCard = ({ category, onClick }) => (
  <div
    onClick={onClick}
    className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer group hover:-translate-y-2 border-2 border-transparent hover:border-blue-200 flex flex-col justify-between h-full"
  >
    <div>
      <div className="text-5xl mb-6 group-hover:scale-110 transition-transform duration-300 text-center">
        {category.icon}
      </div>
      <h3 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-blue-600 transition-colors text-center">
        {category.name}
      </h3>
      <p className="text-gray-600 text-center mb-6 leading-relaxed">
        {category.description}
      </p>
    </div>

    <div className="mt-auto space-y-3">
      <div className="flex justify-between items-center text-sm">
        <span className="text-gray-500">Trámites:</span>
        <span className="font-bold text-blue-600">{category.application_type_count}</span>
      </div>
      <div className="flex justify-between items-center text-sm">
        <span className="text-gray-500">Desde:</span>
        <span className="font-bold text-green-600">$500+</span>
      </div>
      <div className="flex justify-between items-center text-sm">
        <span className="text-gray-500">Tiempo:</span>
        <span className="font-bold text-purple-600">5-30 días</span>
      </div>

      <button className="w-full mt-6 bg-gradient-to-r from-blue-600 to-purple-600 text-white py-3 px-4 rounded-xl font-bold hover:from-blue-700 hover:to-purple-700 transition-all duration-300 transform group-hover:scale-105">
        Ver Especialidad
      </button>
    </div>
  </div>
);

const StatCard = ({ number, label }) => (
  <div className="text-center">
    <div className="text-4xl font-bold text-yellow-300 mb-2">{number}</div>
    <div className="text-lg text-gray-200">{label}</div>
  </div>
);

export default CategoriesPage;